module.exports = "pegasus/assets/styleGroup1-linkedin.png";